var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_914_47754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6783 11.405H3.48837C2.92829 11.405 2.5 10.9767 2.5 10.4166C2.5 9.85652 2.92829 9.42822 3.48837 9.42822H15.6783C16.2384 9.42822 16.6667 9.85652 16.6667 10.4166C16.6667 10.9767 16.2384 11.405 15.6783 11.405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58408 17.4999C9.024 17.4999 8.5957 17.0716 8.5957 16.5115V4.32162C8.5957 3.76155 9.024 3.33325 9.58408 3.33325C10.1442 3.33325 10.5724 3.76155 10.5724 4.32162V16.5115C10.5724 17.0716 10.1442 17.4999 9.58408 17.4999Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_914_47754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.1667,
    height: 14.1667,
    fill: "none",
    transform: "translate(2.5 3.33325)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.1cc741a900b5a7acfd7f631e671b2a65.svg";
export { ForwardRef as ReactComponent };